import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import Spinner from 'react-spinkit';

const ProcessingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h4 {
    color: #0093c5;
  }
  .three-bounce > div {
    background: #9a77b5;
  }
`;

const StatusBoxContainer = styled.div`
  border: 1px solid #9a77b5;
  border-radius: 10px;
  background: white;
  font-size: 16px;
  color: black;
  padding: 20px 20px;
  h3 {
    margin-top: 0;
    color: #9a77b5;
    font-weight: normal;
  }
  .action-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;

class AdministratorStatusBoxes extends React.Component {
  render() {
    const { run, alterAddDrop, processWaitlist, isProcessingWaitlist, updateRunJustAddDrop } = this.props;

    if (!run.add_drop_open && !run.add_drop_visible_to_students) {
      return (
        <StatusBoxContainer>
          <h3>Add/Drop Closed: Students cannot view schedules</h3>
          <p>
            Students are not able to view their schedules nor make any changes to them. You can add and remove students
            from classes or add or remove classes.
          </p>
          <div className="action-group">
            <button className="btn btn-ter btn-purple" onClick={() => updateRunJustAddDrop(true)}>
              Allow Students To View Schedules
            </button>
          </div>
        </StatusBoxContainer>
      )
    } else if (!run.add_drop_open && run.add_drop_visible_to_students) {
      return (
        <StatusBoxContainer>
          <h3>Add/Drop Closed: Students can view schedules</h3>
          <p>
            Students are able to view their schedules but not make any changes to them. You can add and remove students
            from classes or add or remove classes.
          </p>
          <div className="action-group">
            <button className="btn btn-ter btn-purple" onClick={alterAddDrop('manual')}>
              Open Add/Drop Session
            </button>
            <button className="btn btn-ter btn-purple" onClick={() => updateRunJustAddDrop(false)}>
              Turn Off Student Schedule View
            </button>
          </div>
        </StatusBoxContainer>
      )
    } else if (run.add_drop_open && !run.automatic_add_processing) {

      return (
        <StatusBoxContainer>
          <h3>Add/Drop Open:  Manual waitlist processing</h3>
          <p>Waitlists are only processed when you choose to do so.</p>
          <div className="action-group">
            <button className="btn btn-ter btn-purple" onClick={alterAddDrop('close')}>
              Close add/drop session
            </button>
            <button className="btn btn-ter btn-purple" onClick={alterAddDrop('automatic')}>
              Switch to automatic processing{'  '}
              <i className="fa fa-exchange" aria-hidden="true" />
            </button>
          </div>
          {isProcessingWaitlist ? (
            <ProcessingBox>
              <h4>Processing Waitlists...</h4>
              <Spinner spinnerName="three-bounce" className="mt-4" />
            </ProcessingBox>
          ) : (
            <div className="action-group">
              <Button bsStyle="primary" className="pt-fill" onClick={processWaitlist}>
                Process Waitlist
              </Button>
            </div>
          )}
        </StatusBoxContainer>
      );
    } else if (run.add_drop_open && run.automatic_add_processing) {
        return (
          <StatusBoxContainer>
            <h3>Add/Drop Open: Automatic waitlist processing</h3>
            <p>Waitlists are processed every five minutes.</p>
            <div className="action-group">
              <button className="btn btn-ter btn-purple" onClick={alterAddDrop('close')}>
                Close add/drop session
              </button>
              <button className="btn btn-ter btn-purple" onClick={alterAddDrop('manual')}>
                Switch to manual processing{'  '}
                <i className="fa fa-exchange" aria-hidden="true" />
              </button>
            </div>
          </StatusBoxContainer>
        );
    }
  }
}

export default AdministratorStatusBoxes;



// WEBPACK FOOTER //
// ./src/components/runs/AdministratorStatusBoxes.js